var _defs, _path, _path2, _text, _path3, _path4, _text2, _text3, _path5, _path6, _text4, _text5, _text6, _text7, _path7, _path8, _text8, _path9, _path10, _text9, _path11, _path12, _text10, _text11, _text12, _text13, _text14, _text15, _path13, _path14, _text16, _text17, _text18, _text19, _path15, _path16, _text20, _text21, _text22, _text23, _path17, _path18, _text24, _text25, _text26, _text27, _path19, _path20, _text28, _text29, _text30, _text31, _text32, _text33, _path21, _text34, _text35, _path22, _path23, _text36, _path24, _text37, _text38, _path25, _path26, _text39, _text40, _path27, _text41, _text42, _path28, _path29, _text43, _text44, _path30, _text45, _text46, _path31, _path32, _text47, _text48, _text49, _text50, _text51, _path33, _text52, _text53, _path34, _path35, _text54, _text55, _text56, _path36, _text57, _text58, _path37, _path38, _text59, _path39, _text60, _text61, _path40, _path41, _text62, _text63, _path42, _text64, _text65, _path43, _path44, _text66, _text67, _text68, _path45, _text69, _text70, _path46, _path47, _text71, _text72, _text73, _path48, _text74, _text75, _path49, _path50, _text76, _path51, _text77, _text78, _path52, _path53, _text79, _text80, _path54, _text81, _text82, _path55, _path56, _text83, _text84, _path57, _text85, _text86, _path58, _path59, _text87, _text88, _path60, _path61, _text89, _path62, _path63, _text90, _path64, _path65, _text91, _text92, _path66, _path67, _text93, _text94, _path68, _path69, _text95, _text96, _path70, _path71, _text97, _text98, _path72, _path73, _text99, _text100, _path74, _path75, _text101, _path76, _path77, _text102, _text103, _path78, _path79, _text104, _text105, _path80, _text106, _text107, _path81, _path82, _text108, _text109, _path83, _text110, _text111, _path84, _path85, _text112, _text113, _text114, _path86, _text115, _text116, _path87, _path88, _text117, _path89, _text118, _text119, _path90, _path91, _text120, _text121, _text122, _text123, _text124, _path92, _path93, _text125, _text126, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _text127;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStructuEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7610.8 5575.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 83px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-1, .cls-3 {\n        font-family: Cambria-Bold, Cambria;\n        font-weight: 700;\n      }\n\n      .cls-5 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        fill: #329cc6;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        fill-rule: evenodd;\n      }\n\n      .cls-18 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        fill: #002060;\n      }\n\n      .cls-9 {\n        fill: #697fd7;\n      }\n\n      .cls-10 {\n        fill: #7030a0;\n      }\n\n      .cls-20 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-21 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-11 {\n        fill: #d86ecc;\n      }\n\n      .cls-12 {\n        fill: #fff;\n        stroke: #fff;\n      }\n\n      .cls-12, .cls-22, .cls-23 {\n        stroke-dasharray: 27.5 20.62;\n        stroke-miterlimit: 8;\n        stroke-width: 6.88px;\n      }\n\n      .cls-24 {\n        letter-spacing: -.09em;\n      }\n\n      .cls-13, .cls-25 {\n        fill: #00b0f0;\n      }\n\n      .cls-26 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-27 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-28 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        font-family: Cambria, Cambria;\n      }\n\n      .cls-2, .cls-3 {\n        font-size: 73px;\n      }\n\n      .cls-29 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-14 {\n        fill: #145fcb;\n      }\n\n      .cls-30 {\n        letter-spacing: -.08em;\n      }\n\n      .cls-22 {\n        stroke: #145fcb;\n      }\n\n      .cls-22, .cls-23 {\n        fill: none;\n      }\n\n      .cls-31 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-15 {\n        fill: #8ed973;\n      }\n\n      .cls-32 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-33 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-34 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-16 {\n        fill: #f2f4f9;\n      }\n\n      .cls-35 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-17 {\n        fill: #61cbf4;\n      }\n\n      .cls-36 {\n        letter-spacing: 0em;\n      }\n\n      .cls-37 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-38 {\n        letter-spacing: 0em;\n      }\n\n      .cls-39 {\n        letter-spacing: 0em;\n      }\n\n      .cls-40 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-41 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-23 {\n        stroke: #002060;\n      }\n\n      .cls-42 {\n        letter-spacing: 0em;\n      }\n\n      .cls-43 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-44 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-45 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-46 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-4 {\n        fill: #747474;\n        font-family: Bahnschrift, Bahnschrift;\n        font-size: 146px;\n        font-variation-settings: 'wght' 400, 'wdth' 100;\n      }\n\n      .cls-47 {\n        letter-spacing: -.08em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M975.75,70.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07V70.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1042.25,2.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65H985.25l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1298.15 211.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-37",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.68,
    y: 0
  }, "ounders&apos; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 349.85,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 391.2,
    y: 0
  }, "ouncil"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M2446.75,70.51c0-37.04,30.03-67.07,67.07-67.07h1112.86c37.04,0,67.07,30.03,67.07,67.07v221.86c0,37.04-30.03,67.07-67.07,67.07h-1112.86c-37.04,0-67.07-30.03-67.07-67.07V70.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2513.25,2.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65h-1227l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(2802.44 164.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 44.81,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 77.42,
    y: 0
  }, "esident of the "))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(2896.15 252.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Un"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 93.42,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 114.45,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 151.13,
    y: 0
  }, "ersity"))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2446.75,585.04c0-46.73,37.87-84.6,84.6-84.6h1077.8c46.73,0,84.6,37.87,84.6,84.6v279.8c0,46.73-37.87,84.6-84.6,84.6h-1077.8c-46.73,0-84.6-37.87-84.6-84.6v-279.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2513.25,499.94h1113c23.13,0,43.51,14.92,55.55,37.6l1.45,3.4h-1227l1.45-3.4c12.04-22.68,32.42-37.6,55.55-37.6Z"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(2945.01 707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.42,
    y: 0
  }, "e"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(3041.49 707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "c"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(3080.45 707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 0,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.18,
    y: 0
  }, "or"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", null)), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M975.75,614.33c0-36.94,29.95-66.89,66.89-66.89h1113.22c36.94,0,66.89,29.95,66.89,66.89v221.22c0,36.94-29.95,66.89-66.89,66.89h-1113.22c-36.94,0-66.89-29.95-66.89-66.89v-221.22Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1042.25,546.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65H985.25l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(1292.06 755.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Un"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 93.42,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 114.45,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 151.13,
    y: 0
  }, "ersity "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 361.51,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 402.85,
    y: 0
  }, "ouncil"))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3927.75,614.33c0-36.94,29.95-66.89,66.89-66.89h1113.22c36.94,0,66.89,29.95,66.89,66.89v221.22c0,36.94-29.95,66.89-66.89,66.89h-1113.22c-36.94,0-66.89-29.95-66.89-66.89v-221.22Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3994.25,546.94h1113c23.13,0,43.51,11.64,55.55,29.35l1.45,2.65h-1227l1.45-2.65c12.04-17.71,32.42-29.35,55.55-29.35Z"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(4197.05 755.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-31",
    x: 46.66,
    y: 0
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.33,
    y: 0
  }, "visor "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 274.85,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 300.52,
    y: 0
  }, "o the "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 483.2,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 530.18,
    y: 0
  }, "ec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 603.14,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 628.81,
    y: 0
  }, "or"))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1055.95c52.76,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52H368.27c-52.76,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.25,1294.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(481.52 1499.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "First Vice"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(776.57 1499.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(801.2 1499.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.02,
    y: 0
  }, "ec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 111.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.88,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 220.89,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.1,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 327.11,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 362.33,
    y: 0
  }, "outh "))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(569.26 1587.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Af"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 67.58,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.83,
    y: 0
  }, "airs and Spiritual"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1197.46 1587.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(616.04 1675.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "ducational "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 386.28,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 449.26,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 488.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 517.84,
    y: 0
  }, "k"))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1707.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1054.96c52.75,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52h-1054.96c-52.76,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1776.99,1272.48h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1935.79 1554.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Vice"))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2068.13 1554.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2092.77 1554.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.02,
    y: 0
  }, "ec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 111.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.88,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 220.89,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.1,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 327.11,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 372.02,
    y: 0
  }, "cademic "))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2226.12 1642.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Af"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 67.58,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.83,
    y: 0
  }, "airs"))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1055.96c52.75,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52h-1055.96c-52.75,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3224.25,1294.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3296.78 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Vice"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3429.12 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3453.76 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.02,
    y: 0
  }, "ec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 111.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.88,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 220.89,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.1,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 327.11,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 371.13,
    y: 0
  }, "esea"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 509.36,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 538.48,
    y: 0
  }, "ch and "))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3578.79 1629.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Inn"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 105.15,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 142.83,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 178.04,
    y: 0
  }, "ation"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4607.75,1390.96c0-52.75,42.77-95.52,95.52-95.52h1055.96c52.75,0,95.52,42.77,95.52,95.52v315.96c0,52.75-42.77,95.52-95.52,95.52h-1055.96c-52.75,0-95.52-42.77-95.52-95.52v-315.96Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4674.25,1294.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4844.74 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Vice"))), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4977.08 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5001.72 1541.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.02,
    y: 0
  }, "ec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 111.82,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 135.88,
    y: 0
  }, "or "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 220.89,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.1,
    y: 0
  }, "or Financial "))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4898.36 1629.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 132.95,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 174.59,
    y: 0
  }, "conomic Af"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 521.87,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 543.12,
    y: 0
  }, "airs"))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,1997.85c0-68.16,55.25-123.41,123.41-123.41h1000.18c68.16,0,123.41,55.25,123.41,123.41v408.18c0,68.16-55.25,123.41-123.41,123.41H396.16c-68.16,0-123.41-55.25-123.41-123.41v-408.18Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.25,1873.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(450.15 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 469.83,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 505.05,
    y: 0
  }, "outh Af"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 732.74,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 753.99,
    y: 0
  }, "airs, "))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(461.04 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Spiritual"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(731.46 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(756.09 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "ducational "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 386.28,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 449.26,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 488.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 517.84,
    y: 0
  }, "k, "))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(487.97 2394.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 197.36,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 218.57,
    y: 0
  }, "ormation "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 524.44,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 568.46,
    y: 0
  }, "esou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 714.49,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 743.62,
    y: 0
  }, "ce "))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(792 2482.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cen"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 117.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 141.47,
    y: 0
  }, "er"))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M814.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(861.73 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(936.78 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,2696.07c0-50.06,40.58-90.63,90.63-90.63h1065.75c50.05,0,90.63,40.57,90.63,90.63v299.74c0,50.05-40.58,90.63-90.63,90.63H363.38c-50.05,0-90.63-40.58-90.63-90.63v-299.74Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M339.25,2604.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.46,32.43-42.19,55.55-42.19Z"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(699.83 2949.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 0,
    y: 0
  }, "Ps"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 71.75,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 107.11,
    y: 0
  }, "chologist"))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M814.25,2705.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(875.04 2817.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(923.73 2817.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1707.75,1979.01c0-57.75,46.82-104.57,104.57-104.57h1036.86c57.75,0,104.57,46.82,104.57,104.57v345.86c0,57.75-46.82,104.57-104.57,104.57h-1036.86c-57.75,0-104.57-46.82-104.57-104.57v-345.86Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1774.2,1873.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1964.72 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.91,
    y: 0
  }, "cademic Methodology "))), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2141.18 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department"))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2249.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2296.31 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2378.23 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1707.75,2606.79c0-61.5,49.85-111.35,111.35-111.35h1023.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1023.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1774.2,2494.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1973.56 2839.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ma"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 95.17,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 125.01,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: 162.04,
    y: 0
  }, "eting and Student "))), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1968.77 2927.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 64.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.47,
    y: 0
  }, "ernship Department"))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2249.25,2595.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2296.31 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2379.38 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,1997.85c0-68.16,55.25-123.41,123.41-123.41h1000.18c68.16,0,123.41,55.25,123.41,123.41v408.18c0,68.16-55.25,123.41-123.41,123.41h-1000.18c-68.16,0-123.41-55.25-123.41-123.41v-408.18Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3224.25,1873.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3243.66 2218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Scientific "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 770.49,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 814.51,
    y: 0
  }, "esea"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 952.74,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-42",
    x: 981.86,
    y: 0
  }, "ch, "))), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3253.35 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Inn"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 105.15,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 142.83,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 178.04,
    y: 0
  }, "ation, Scientific"))), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3910.12 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3934.75 2306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.1,
    y: 0
  }, "edagogical "))), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3205.98 2394.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Staff "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 156.84,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 197.61,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 226.56,
    y: 0
  }, "aining, and "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 584.32,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 621.89,
    y: 0
  }, "alen"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 753.7,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 777.76,
    y: 0
  }, "ed Students"))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3699.25,1974.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.48 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3829.56 2086.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,2696.85c0-68.16,55.25-123.41,123.41-123.41h1000.18c68.16,0,123.41,55.25,123.41,123.41v408.18c0,68.16-55.25,123.41-123.41,123.41h-1000.18c-68.16,0-123.41-55.25-123.41-123.41v-408.18Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M3224.25,2572.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3275.01 2917.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Digital "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 691,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 732.64,
    y: 0
  }, "ducation "))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3351.41 3005.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.36,
    y: 0
  }, "echnologies and Local and "))), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3421.53 3093.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 64.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.47,
    y: 0
  }, "ernational "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 426.67,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 471.43,
    y: 0
  }, "ankings"))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3699.25,2673.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.48 2785.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3821.54 2785.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4620.75,2606.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4687.25,2494.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5014.44 2839.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Chief Engineer"))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M5162.25,2595.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5218.69 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5267.39 2707.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4620.75,1957.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4687.25,1845.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4849.72 2212.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.91,
    y: 0
  }, "ccounting and Financial "))), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4908.16 2300.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Planning Department"))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M5162.25,1946.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5209.67 2058.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5292.74 2058.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4620.75,3241.98c0-61.6,49.94-111.54,111.54-111.54h1023.92c61.6,0,111.54,49.94,111.54,111.54v368.92c0,61.6-49.94,111.54-111.54,111.54h-1023.92c-61.6,0-111.54-49.94-111.54-111.54v-368.92Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4687.25,3129.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4820.36 3474.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.36,
    y: 0
  }, "echnical Main"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 466.37,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 490.43,
    y: 0
  }, "enance and "))), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4898.66 3562.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.91,
    y: 0
  }, "dminist"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 283.52,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 312.46,
    y: 0
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 372.81,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 391.63,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 426.99,
    y: 0
  }, "e Af"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-34",
    x: 546.25,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 567.5,
    y: 0
  }, "airs "))), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5054.54 3650.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department"))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M5162.25,3230.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5171.2 3342.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22"))), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5321.87 3342.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M4620.75,3868.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M4687.25,3756.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4796.41 4101.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 41.45,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.58,
    y: 0
  }, "ess Service and "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 560.9,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 605.81,
    y: 0
  }, "dmission "))), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4909.52 4189.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 41.45,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.58,
    y: 0
  }, "ocess Coo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 374.48,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 403.6,
    y: 0
  }, "dination "))), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(5054.54 4277.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department"))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M5162.25,3856.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5209.67 3968.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(5284.72 3968.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,3514.06c0-50.05,40.58-90.63,90.63-90.63h1065.75c50.05,0,90.63,40.57,90.63,90.63v299.75c0,50.05-40.58,90.63-90.63,90.63H363.38c-50.05,0-90.63-40.57-90.63-90.63v-299.75Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M339.25,3422.94h1113.01c23.12,0,43.51,16.73,55.55,42.18l1.45,3.82H282.25l1.45-3.82c12.04-25.45,32.43-42.18,55.55-42.18Z"
  })), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(584.49 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.68,
    y: 0
  }, "aculty of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 319.13,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 359.23,
    y: 0
  }, "edagogy"))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M814.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(861.73 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(936.78 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1717.75,3514.06c0-50.05,40.57-90.62,90.62-90.62h1064.74c50.06,0,90.63,40.57,90.63,90.62v299.75c0,50.05-40.57,90.62-90.63,90.62h-1064.74c-50.05,0-90.62-40.57-90.62-90.62v-299.75Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1784.2,3422.94h1112.1c23.1,0,43.47,16.73,55.5,42.18l1.45,3.82h-1226l1.45-3.82c12.03-25.45,32.4-42.18,55.5-42.18Z"
  })), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1965.65 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.68,
    y: 0
  }, "aculty of Philology and "))), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2223.67 3855.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "His"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 101.77,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 125.83,
    y: 0
  }, "ory"))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M2259.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2305.82 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(2380.87 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,3514.06c0-50.05,40.57-90.63,90.63-90.63h1065.74c50.06,0,90.63,40.57,90.63,90.63v299.75c0,50.05-40.57,90.63-90.63,90.63h-1065.74c-50.06,0-90.63-40.57-90.63-90.63v-299.75Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3224.25,3422.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3351.7 3767.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-40",
    x: 0,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.68,
    y: 0
  }, "aculty of Mathematics and "))), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3611.32 3855.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "conomics"))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M3699.25,3523.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3746.49 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(3821.54 3635.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43H344.18c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M339.25,3969.94h1113.01c23.12,0,43.51,16.73,55.55,42.19l1.45,3.81H282.25l1.45-3.81c12.04-25.45,32.43-42.19,55.55-42.19Z"
  })), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(473.53 4136.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 469.83,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 509.93,
    y: 0
  }, "edagogical "))), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(486.59 4224.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "ducation and "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 463.77,
    y: 0
  }, "Ps"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 535.52,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 570.88,
    y: 0
  }, "chology"))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M272.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43H344.18c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M339.25,4347.94h1113.01c23.12,0,43.51,16.73,55.55,42.18l1.45,3.82H282.25l1.45-3.82c12.04-25.45,32.43-42.18,55.55-42.18Z"
  })), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(404.84 4552.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Sports "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 687.73,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 732.64,
    y: 0
  }, "ct"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 789.53,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 808.35,
    y: 0
  }, "vities"))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1717.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1784.2,3969.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.45,32.4-42.19,55.5-42.19Z"
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1957.24 4175.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Philology"))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1717.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1784.2,4347.94h1112.1c23.1,0,43.47,16.73,55.5,42.18l1.45,3.82h-1226l1.45-3.82c12.03-25.45,32.4-42.18,55.5-42.18Z"
  })), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1985.56 4552.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 469.83,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 506.15,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 544.9,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 574.02,
    y: 0
  }, "eign "))), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2174.07 4640.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Languages"))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,4041.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3224.25,3969.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.45,32.42-42.19,55.55-42.19Z"
  })), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3343.28 4139.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Mathematics "))), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3455.07 4227.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and Natu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 283.3,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 312.25,
    y: 0
  }, "al Sciences"))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,4419.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3224.25,4347.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3355.76 4519.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 534.24,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 555.45,
    y: 0
  }, "ormation "))), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3601.48 4607.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-47",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.36,
    y: 0
  }, "echnology"))), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1717.75,4796.87c0-39.45,31.98-71.43,71.43-71.43h1103.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1103.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1784.2,4724.94h1112.1c23.1,0,43.47,16.73,55.5,42.18l1.45,3.82h-1226l1.45-3.82c12.03-25.45,32.4-42.18,55.5-42.18Z"
  })), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1985.56 4930.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-41",
    x: 469.83,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 506.15,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 544.9,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 574.02,
    y: 0
  }, "eign "))), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2192.98 5018.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Philology"))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1717.75,5174.65c0-39.33,31.88-71.21,71.21-71.21h1103.58c39.33,0,71.21,31.88,71.21,71.21v184.58c0,39.33-31.88,71.21-71.21,71.21h-1103.58c-39.33,0-71.21-31.88-71.21-71.21v-184.58Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1784.2,5102.94h1112.1c23.1,0,43.47,16.73,55.5,42.19l1.45,3.81h-1226l1.45-3.81c12.03-25.46,32.4-42.19,55.5-42.19Z"
  })), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(1945.49 5307.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Social and "))), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(2073.07 5395.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.1,
    y: 0
  }, "olitical Sciences"))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,4796.87c0-39.45,31.98-71.43,71.43-71.43h1104.14c39.45,0,71.43,31.98,71.43,71.43v185.14c0,39.45-31.98,71.43-71.43,71.43h-1104.14c-39.45,0-71.43-31.98-71.43-71.43v-185.14Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3224.25,4724.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3375.55 4930.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 469.83,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 511.46,
    y: 0
  }, "conomics"))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M3157.75,5174.65c0-39.33,31.88-71.21,71.21-71.21h1104.58c39.33,0,71.21,31.88,71.21,71.21v184.58c0,39.33-31.88,71.21-71.21,71.21h-1104.58c-39.33,0-71.21-31.88-71.21-71.21v-184.58Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M3224.25,5102.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3422.06 5307.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of Finance"))), _text103 || (_text103 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3617.68 5395.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 174.02,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 203.14,
    y: 0
  }, "edit"))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,2069.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,1957.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text104 || (_text104 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6339.62 2324.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department of "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 469.83,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 511.46,
    y: 0
  }, "ducation "))), _text105 || (_text105 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6494.95 2412.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quality Cont"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 386.56,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 415.69,
    y: 0
  }, "ol"))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M6652.25,2058.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text106 || (_text106 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 2170.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text107 || (_text107 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 2170.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,1427.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,1315.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text108 || (_text108 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6326.64 1683.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 64.41,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 88.47,
    y: 0
  }, "ernational Coope"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 621.43,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 650.37,
    y: 0
  }, "ation "))), _text109 || (_text109 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6544.53 1771.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department"))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M6652.25,1416.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text110 || (_text110 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 1528.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text111 || (_text111 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 1528.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,2716.65c0-66.39,53.82-120.21,120.21-120.21h1006.58c66.39,0,120.21,53.82,120.21,120.21v397.59c0,66.39-53.82,120.21-120.21,120.21h-1006.58c-66.39,0-120.21-53.82-120.21-120.21v-397.59Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,2595.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.46,32.42-42.19,55.55-42.19Z"
  })), _text112 || (_text112 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6203.51 2963.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Department "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 392.91,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 414.12,
    y: 0
  }, "or Handling P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 840.57,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 879.42,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 915.42,
    y: 0
  }, "sical "))), _text113 || (_text113 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6305.95 3051.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and Le"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 207.74,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 243.2,
    y: 0
  }, "al Entities&apos; Appeals, "))), _text114 || (_text114 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6192.9 3139.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 45.48,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 74.6,
    y: 0
  }, "ch"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 147.07,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 165.89,
    y: 0
  }, "ving, Cont"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 476.07,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 505.19,
    y: 0
  }, "ol, and Moni"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 887.05,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 911.11,
    y: 0
  }, "oring"))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M6652.25,2696.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text115 || (_text115 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 2808.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text116 || (_text116 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6777.02 2808.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,3392.79c0-61.5,49.85-111.35,111.35-111.35h1024.3c61.5,0,111.35,49.85,111.35,111.35v368.3c0,61.5-49.85,111.35-111.35,111.35h-1024.3c-61.5,0-111.35-49.85-111.35-111.35v-368.3Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,3280.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text117 || (_text117 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6254.13 3647.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Human "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-33",
    x: 243.63,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 287.65,
    y: 0
  }, "esou"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 433.69,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 462.81,
    y: 0
  }, "ces Department"))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M6652.25,3381.44c0-15.74,12.76-28.5,28.5-28.5h114c15.74,0,28.5,12.76,28.5,28.5v124c0,15.74-12.76,28.5-28.5,28.5h-114c-15.74,0-28.5-12.76-28.5-28.5v-124Z"
  })), _text118 || (_text118 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6699.67 3493.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text119 || (_text119 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(6775.3 3493.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,4008.07c0-42.88,34.76-77.64,77.64-77.64h1091.72c42.88,0,77.64,34.76,77.64,77.64v327.72c0,42.88-34.76,77.64-77.64,77.64h-1091.72c-42.88,0-77.64-34.76-77.64-77.64v-327.72Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,3929.94h1113c23.13,0,43.51,16.73,55.55,42.19l1.45,3.81h-1227l1.45-3.81c12.04-25.45,32.42-42.19,55.55-42.19Z"
  })), _text120 || (_text120 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6405.91 4130.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Le"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 74.78,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 110.25,
    y: 0
  }, "al Consultant and"))), _text121 || (_text121 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6290.16 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Anti"))), _text122 || (_text122 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6421.93 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "-"))), _text123 || (_text123 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6446.56 4218.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Corruption Compliance "))), _text124 || (_text124 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6285.55 4306.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cont"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 145.25,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 174.37,
    y: 0
  }, "ol "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-46",
    x: 249.01,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-32",
    x: 283.8,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 319.8,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 351.17,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 375.23,
    y: 0
  }, "em Management"))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M6110.75,4556.1c0-46.76,37.9-84.66,84.66-84.66h1077.68c46.76,0,84.66,37.9,84.66,84.66v172.68c0,46.76-37.9,84.66-84.66,84.66h-1077.68c-46.76,0-84.66-37.9-84.66-84.66v-172.68Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M6177.25,4470.94h1113c23.13,0,43.51,16.73,55.55,42.18l1.45,3.82h-1227l1.45-3.82c12.04-25.45,32.42-42.18,55.55-42.18Z"
  })), _text125 || (_text125 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6373.17 4623.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sec"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-44",
    x: 104.01,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 133.13,
    y: 0
  }, "etary of the Hi"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-36",
    x: 576.12,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 611.7,
    y: 0
  }, "her "))), _text126 || (_text126 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(6450.2 4711.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.63,
    y: 0
  }, "ducation Council"))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2222.75,179.15h224.14v4.58h-224.14v-4.58ZM2222.75,195.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM2446.89,167.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.04,501.27v-141.84s-4.58,0-4.58,0v141.84s4.58,0,4.58,0ZM3056,501.27l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM3083.5,359.43l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2222.75,723.15h224.14v4.58h-224.14v-4.58ZM2222.75,739.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM2446.89,711.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3693.75,727.73h234.13v-4.58h-234.13s0,4.58,0,4.58ZM3693.75,711.69l-13.75,13.75,13.75,13.75,13.75-13.75-13.75-13.75ZM3927.88,739.19l13.75-13.75-13.75-13.75-13.75,13.75,13.75,13.75Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.04,1072.58v-123.14s-4.58,0-4.58,0v123.14s4.58,0,4.58,0ZM3056,1072.58l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM3083.5,949.43l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2333.04,1295.48v-224.04s-4.58,0-4.58,0v224.04s4.58,0,4.58,0ZM2317,1295.48l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM2344.5,1071.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M13.75,1068.15l7583.3,6.05v4.58L13.75,1072.73v-4.58ZM13.74,1084.19l-13.74-13.76,13.76-13.74,13.74,13.76-13.76,13.74ZM7597.06,1062.74l13.74,13.76-13.76,13.74-13.74-13.76,13.76-13.74Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M888.46,1295.09v-222.65h4.58v222.65s-4.58,0-4.58,0ZM904.5,1295.09l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM877,1072.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3771.46,1294.88v-219.44h4.58v219.44h-4.58ZM3787.5,1294.88l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM3760,1075.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M5241.46,1294.72v-219.28h4.58v219.28h-4.58ZM5257.5,1294.72l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75ZM5230,1075.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7599.04,4642.06V1075.44s-4.58,0-4.58,0v3566.62s4.58,0,4.58,0ZM7583,4642.06l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75ZM7610.5,1075.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4535.75,1547.15h71.91v4.58h-71.91v-4.58ZM4535.75,1563.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4607.66,1535.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4538.04,1548.44v2503.78h-4.58V1548.44h4.58ZM4522,1548.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM4549.5,4052.22l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4537.75,2140.15h83.17v4.58h-83.17v-4.58ZM4537.75,2156.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.92,2128.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4536.75,2788.15h84.05v4.58h-84.05v-4.58ZM4536.75,2804.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,2776.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4536.75,3424.15h84.05v4.58h-84.05v-4.58ZM4536.75,3440.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,3412.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M4536.75,4050.15h84.05v4.58h-84.05v-4.58ZM4536.75,4066.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM4620.8,4038.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3069.75,1546.15l87.33.16v4.58s-87.33-.16-87.33-.16v-4.58ZM3069.72,1562.19l-13.72-13.78,13.78-13.72,13.72,13.78-13.78,13.72ZM3157.1,1534.85l13.72,13.77-13.77,13.73-13.73-13.78,13.78-13.72Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.04,1548.44v1352.52h-4.58v-1352.52h4.58ZM3056,1548.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM3083.5,2900.96l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3071.75,2280.15h86.12v4.58h-86.12v-4.58ZM3071.75,2296.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3157.87,2268.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3070.75,2899.15h86.72v4.58h-86.72v-4.58ZM3070.75,2915.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3157.47,2887.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1622.75,1546.15h84.72v4.58h-84.72v-4.58ZM1622.75,1562.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.47,1534.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1620.46,1548.44v1242.37s4.58,0,4.58,0v-1242.37s-4.58,0-4.58,0ZM1636.5,1548.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75ZM1609,2790.81l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1627.75,2150.15h79.62v4.58h-79.62v-4.58ZM1627.75,2166.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.37,2138.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1622.75,2788.15h84.72v4.58h-84.72v-4.58ZM1622.75,2804.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1707.47,2776.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,1546.15h83.12v4.58h-83.12v-4.58ZM189.75,1562.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,1534.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M187.46,1548.44v1324.26s4.58,0,4.58,0v-1324.26s-4.58,0-4.58,0ZM203.5,1548.44l-13.75-13.75-13.75,13.75,13.75,13.75,13.75-13.75ZM176,2872.7l13.75,13.75,13.75-13.75-13.75-13.75-13.75,13.75Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,2222.15h83.12v4.58h-83.12v-4.58ZM189.75,2238.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,2210.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,2864.15h83.12v4.58h-83.12v-4.58ZM189.75,2880.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,2852.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M19.04,1070.44v2249.72h-4.58V1070.44h4.58ZM3,1070.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM30.5,3320.15l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M16.75,3318.15h3772.18v4.58H16.75v-4.58ZM16.75,3334.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3788.93,3306.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,3674.15h83.12v4.58h-83.12v-4.58ZM189.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M194.04,3676.44v854.95h-4.58v-854.95s4.58,0,4.58,0ZM178,3676.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM205.5,4531.39l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,4149.15h83.12v4.58h-83.12v-4.58ZM189.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M189.75,4528.15h83.12v4.58h-83.12v-4.58ZM189.75,4544.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM272.88,4516.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M896.04,3320.44v105.8h-4.58v-105.8s4.58,0,4.58,0ZM880,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM907.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M2335.04,3320.44v105.8h-4.58v-105.8h4.58ZM2319,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM2346.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3791.04,3320.44v105.8h-4.58v-105.8h4.58ZM3775,3320.44l13.75-13.75,13.75,13.75-13.75,13.75-13.75-13.75ZM3802.5,3426.23l-13.75,13.75-13.75-13.75,13.75-13.75,13.75,13.75Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.75,3674.15h83.12v4.58h-83.12v-4.58ZM1632.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.07,3676.44l-1.61,1589.29h4.58l1.61-1589.29h-4.58ZM1648.11,3676.45l-13.74-13.76-13.76,13.74,13.74,13.76,13.76-13.74ZM1619,5265.72l13.74,13.76,13.76-13.74-13.74-13.76-13.76,13.74Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.75,4149.15h83.12v4.58h-83.12v-4.58ZM1632.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.75,4525.15h83.12v4.58h-83.12v-4.58ZM1632.75,4541.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4513.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.75,5263.15h83.12v4.58h-83.12v-4.58ZM1632.75,5279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,5251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1632.75,4905.15h83.12v4.58h-83.12v-4.58ZM1632.75,4921.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM1715.88,4893.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.75,3674.15h83.12v4.58h-83.12v-4.58ZM3072.75,3690.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,3662.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.07,3676.44l-1.61,1589.29h4.58l1.61-1589.29h-4.58ZM3088.11,3676.45l-13.74-13.76-13.76,13.74,13.74,13.76,13.76-13.74ZM3059,5265.72l13.74,13.76,13.76-13.74-13.74-13.76-13.76,13.74Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.75,4149.15h83.12v4.58h-83.12v-4.58ZM3072.75,4165.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4137.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.75,4525.15h83.12v4.58h-83.12v-4.58ZM3072.75,4541.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4513.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.75,5263.15h83.12v4.58h-83.12v-4.58ZM3072.75,5279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,5251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3072.75,4905.15h83.12v4.58h-83.12v-4.58ZM3072.75,4921.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM3155.87,4893.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,1610.15h239.28v4.58h-239.28v-4.58ZM7357.75,1626.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,1598.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,2263.15h239.28v4.58h-239.28v-4.58ZM7357.75,2279.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,2251.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,2936.15h239.28v4.58h-239.28v-4.58ZM7357.75,2952.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,2924.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,3574.15h239.28v4.58h-239.28v-4.58ZM7357.75,3590.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,3562.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,4164.15h239.28v4.58h-239.28v-4.58ZM7357.75,4180.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,4152.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M7357.75,4640.15h239.28v4.58h-239.28v-4.58ZM7357.75,4656.19l-13.75-13.75,13.75-13.75,13.75,13.75-13.75,13.75ZM7597.03,4628.69l13.75,13.75-13.75,13.75-13.75-13.75,13.75-13.75Z"
  })), _text127 || (_text127 = /*#__PURE__*/React.createElement("text", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuEn);
export default __webpack_public_path__ + "static/media/structu_en.a73e863c37f6d1731ad8faef92a685a3.svg";
export { ForwardRef as ReactComponent };